import QuedTableContainer from "components/Common/QuedTableContainer"
import LocationTableContainer from "components/Common/LocationTableContainer"
import React, { useState, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Input, InputGroup, Label, Modal, Row } from "reactstrap"
import { Box } from "@mui/material"
import Cookies from "js-cookie"
import { get } from "utils/apiClient"

const LocationManagement = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [editingRow, setEditingRow] = useState(null)
  const [showText, setShowText] = useState(false)
  const [searchKey, setSearchKey] = useState()
  const [searchBy, setSearchBy] = useState('address')

  document.title = "Location Management | Qued Portal"

  const editRow = row => {
    console.log(row)
    setEditingRow(row?.id)
  }

  const getColumns = () => {
    return useMemo(
      () => [
        {
          accessor: "tLocationName",
          Header: "Location Name",
        },
        {
          accessor: "appt_sys_ref",
          Header: "Appointment System",
        },
        {
          accessor: "locationId",
          Header: "Location Id",
        },
      ],
      []
    )
  }

  useEffect(() => {
    //fetchData()
  }, [])

  const fetchData = async (val) => {
    setLoading(true)
    try {
      const response = await get("locations?search_term=" + val + '&searchBy='+searchBy)
      setData(response)
      setLoading(false)
    } catch (error) {
      console.error("Error:" + error)
      setLoading(false)
      console.error(error)
    }
  }

  const columns = getColumns()

  const handleAddMapping = () => {
    console.log("testing new button click")
  }

  const refreshTable = () => {
    search(searchKey)
  }

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const search = (val) => {
    setSearchKey(val)
    if (val.length > 1) {
      fetchData(val)
    }

    if (val.length == 0) {
      clearSearch()
    }

  }

  const clearSearch = () => {
    setData([])
    setSearchKey('')
  }

  const setSearchType = (val) => {
    clearSearch()
    setSearchBy(val)
  }



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <div className="mb-2 me-2">
                      <div className="position-relative">
                        <InputGroup className="mb-3">
                          <Label className="input-group-text">Search By:</Label>
                          <select
                            className="form-select"
                            style={{ maxWidth: "200px" }}
                            onChange={e => { setSearchType(e.target.value) }}
                          >
                            <option value="address" defaultValue>
                              Address / Location Name
                            </option>
                            <option value="apptSystem">Appointment System</option>
                            <option value="locationId">Location Id</option>
                          </select>
                          <input type="text" className="form-control p-2" value={searchKey} onChange={e => { search(e.target.value) }} placeholder="Type to search locations..." />
                          {searchKey && (
                            <i
                              className="bx bx-x position-absolute cursor-pointer"
                              style={{
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                fontSize: '1.5rem',
                                color: '#888',
                                cursor: 'pointer'
                              }}
                              onClick={() => clearSearch()}
                            ></i>
                          )}
                        </InputGroup>

                      </div></div>
                  </Row>
                  <Row className="mt-2">
                    <LocationTableContainer
                      columns={columns}
                      data={data}
                      isGlobalFilter={false}
                      isAddOptions={true}
                      customPageSize={50}
                      handleAddMapping={handleAddMapping}
                      editRow={editRow}
                      editingRow={editingRow}
                      loading={loading}
                      refreshTable={refreshTable}
                      className="custom-header-css"
                    />
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LocationManagement
